import React from 'react';
import { Linking, ScrollView, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { ThemeColors } from '@/src/context/ThemeContext';
import { BlogPost } from '@/src/domain/models/BlogPost';
import { useTranslation } from '@/src/i18n';
import { styles } from './WhatsNewScreen.styles';

export interface WhatsNewScreenProps {
  posts: BlogPost[];
  colors: ThemeColors;
}

export const WhatsNewScreen: React.FC<WhatsNewScreenProps> = ({ posts, colors }) => {
  const { t, language } = useTranslation();

  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr + 'T00:00:00');
    return date.toLocaleDateString(language === 'es' ? 'es-ES' : 'en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const handlePostPress = (slug: string) => {
    Linking.openURL(`https://tournaly.app/blog/${slug}`);
  };

  return (
    <ScrollView
      style={[styles.container, { backgroundColor: colors.background }]}
      contentContainerStyle={styles.scrollContent}
    >
      {posts.map((post) => {
        const displayTitle = language === 'es' ? post.titleEs : post.title;
        const displaySummary = language === 'es' ? post.summaryEs : post.summary;

        return (
          <TouchableOpacity
            key={post.slug}
            style={[styles.card, { backgroundColor: colors.card, borderColor: colors.border }]}
            onPress={() => handlePostPress(post.slug)}
            activeOpacity={0.8}
          >
            <View style={styles.tagsRow}>
              {post.tags.map((tag) => (
                <View key={tag} style={[styles.tagPill, { borderColor: colors.primary }]}>
                  <Text style={[styles.tagText, { color: colors.primary }]}>{tag}</Text>
                </View>
              ))}
            </View>

            <Text style={[styles.cardTitle, { color: colors.text }]}>{displayTitle}</Text>

            <Text style={[styles.cardDate, { color: colors.textTertiary }]}>
              {formatDate(post.date)}
            </Text>

            <Text style={[styles.cardSummary, { color: colors.textSecondary }]} numberOfLines={3}>
              {displaySummary}
            </Text>

            <View style={styles.readMoreRow}>
              <Text style={[styles.readMoreText, { color: colors.primary }]}>
                {t('blog.readMore')}
              </Text>
              <Ionicons name="open-outline" size={14} color={colors.primary} />
            </View>
          </TouchableOpacity>
        );
      })}
    </ScrollView>
  );
};
